<template>
	<div style="height: 100%;">
		<content-list-data :key="id" :list="id" :search="data_search" v-if="id != 'default'" enable-pin include-path ></content-list-data>
<!--
		<action-buttons v-if="id != 'default'" @add="open_add_data"></action-buttons>-->
	</div>
</template>

<script>
import ContentListData from './Data'
import ActionButtons from '@/components/ActionButtons.vue'


export default {
	props: ["id"],
	components: {
		ContentListData,
		ActionButtons
	},
	watch: {
		"id": function(newValue) {
			this.$forceUpdate();
		}
	},
	data () {
		return {
		}
	},
	methods: {
		open_add_data () {
			this.$router.push("/content/list/"+this.id+"/data/new");
		},
	},
	computed: {
		data_search () {
			return this.$store.state.search_text;
		}
	}

}
</script>